import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  systemTaxonomyPopoverTitle: {
    id: 'course-authoring.taxonomy-list.popover.system-defined.title',
    defaultMessage: 'Taxonomía del sistema',
  },
  systemTaxonomyPopoverBody: {
    id: 'course-authoring.taxonomy-list.popover.system-defined.body',
    defaultMessage: 'Se trata de una taxonomía a nivel de sistema y está habilitada por defecto.',
  },
  systemDefinedBadge: {
    id: 'course-authoring.taxonomy-list.badge.system-defined.label',
    defaultMessage: 'Nivel de sistema',
  },
});

export default messages;
